import React from 'react';

// entoro libs
import { SnackBar } from 'entoro-shared';

// libs
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';

// hocs
import withTenant from './withTenant';

// styles
import setTheme from '../styles/setTheme';

// layout
import Nav from '../Layouts/Nav';

const withLayout = (Component) =>
  withTenant((props) => {
    const { tenant } = props;

    const customTheme = setTheme(tenant);

    return (
      <MuiThemeProvider theme={createMuiTheme(customTheme)}>
        <Nav />
        <Component {...props} />
        <SnackBar />
      </MuiThemeProvider>
    );
  });

export default withLayout;



// WEBPACK FOOTER //
// ./src/components/withLayout.js